<template>
  <div class="home">
    <MainHeader />
    <div class="content">
      <div class="banner">
        <div class="bannerBox">
          <p>独立  专业  智能</p>
          <span>全流程、多维度信用分析与投资者服务解决方案</span>
        </div>
      </div>
      <div class="productBox">
        <div class="productContent">
          <div class="productTitle">
            <p>SaaS产品</p>
            <p>
              汇集公开数据和中诚信特色信用数据，采用先进的信用风险量化建模技术
            </p>
            <!-- <p>为金融及类金融机构风险管理提供标准化智能风控工具</p> -->
          </div>
          <div class="productMainContent">
            <ul>
              <li v-for="(item, index) in productIntroduce" :key="index">
                <div class="productTitle">{{ item.title }}</div>
                <div class="introduceTitle">
                  <img :src="item.rankImg" />
                  <p>{{ item.introduceTitle }}</p>
                </div>
                <p class="productContent">{{ item.content }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="dataBox">
        <p>解决方案</p>
        <p>提供信用风险咨询、专项数据服务、专题研究服务、信评模型研发、</p>
        <p>系统定制化开发等解决方案及服务</p>
        <img src="../../assets/home/dataCont.png" class="dataBoxImg" />
      </div>
      <div class="studyBox">
        <div class="studyBoxTitle">
          <p>专题研究</p>
          <p>中诚信系列专题研究报告，从微观企业到宏观区域行业</p>
          <p>紧密围绕市场关切，持续提供清晰观点</p>
        </div>
        <ul>
          <li v-for="(item, index) in studyContent" :key="index">
            <img :src="item.studyImg" />
            <p>{{ item.studyIntroduce }}</p>
            <p>{{ item.studycontent }}</p>
          </li>
        </ul>
        <!-- <div class="studyBoxText">中诚信系列专题研究报告，从微观企业到宏观区域行业，紧密围绕市场关切，持续提供清晰观点</div> -->
      </div>
      <div class="serveBox">
        <p>会员服务</p>
        <p>打通市场全链条，减少信息不对称，纵享权威专家库</p>
        <img src="../../assets/home/serveCon.png" class="serveBoxImg" />
      </div>
    </div>
    <Mainfooter />
  </div>
</template>

<script>
import MainHeader from "@/components/MainHeader";
import Mainfooter from "@/components/Mainfooter";

export default {
  name: "home",
  metaInfo() {
    return {
      title: this.pageTitle,
      meta: [
        {
          name: "keyWords",
          content: this.keyWords,
        },
        {
          name: "description",
          content: this.description,
        },
      ],
    };
  },
  data() {
    return {
      pageTitle: "首页",
      keywords: "",
      describes: "",
      productIntroduce: [
        {
          title: "智象风控",
          rankImg: require("../../assets/home/01.png"),
          introduceTitle: "一站式信用风险管理平台",
          content:
            "依托中诚信多年积累的信用风险分析技术，整合多维度信用大数据进行量化建模，为信用风险管理打造标准化智能工具，并提供定制化风控解决方案。",
        },
        {
          title: "智象预警",
          rankImg: require("../../assets/home/02.png"),
          introduceTitle: "风险预警平台",
          content:
            "运用“大数据+量化模型+专家规则+决策引擎”等金融科技手段，整合多维度揭示监控主体信用风险水平，叠加形成综合预警结论，并进行多维度归因分析。",
        },
        {
          title: "智象内评",
          rankImg: require("../../assets/home/03.png"),
          introduceTitle: "信用风险内部评级系统",
          content:
            "评级系统为需要对债券市场进行信用风险评估的各类机构搭建一个对全市场发债主体及债券信用风险进行内部评级的管理系统。",
        },
      ],
      studyContent: [
        {
          studyImg: require("../../assets/home/studyOne.png"),
          studyIntroduce: "解读城投行业趋势，分析市场",
          studycontent: "热点，并展望发展趋势",
        },
        {
          studyImg: require("../../assets/home/studyTwo.png"),
          studyIntroduce: "对中国债券市场30余个主要和细",
          studycontent: "分行业出具年度行业展望报告",
        },
        {
          studyImg: require("../../assets/home/studyThree.png"),
          studyIntroduce: "“走遍城投”系列报告立足区域视角",
          studycontent: "直击风险要害",
        },
        {
          studyImg: require("../../assets/home/studyFour.png"),
          studyIntroduce: "新发债日报深挖个券价值",
          studycontent: "为信用债投资提供参考",
        },
      ],
    };
  },
  components: {
    MainHeader,
    Mainfooter,
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.$http
        .get("newIndexPage/getTitle", { htmlName: this.pageTitle })
        .then((res) => {
          // 设置title时 metaInfo 会同时更新
          this.pageTitle = res.data.htmlTitle;
          this.keywords = res.data.keywords;
          this.describes = res.data.describes;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index';
</style>